export default __webpack_public_path__ + "static/illustration-content.url-a291fc534226e44fcfc038b05ed721dd.svg";